import React from "react";
import { CustomCardStock } from "../../components/customCardStock/index";
import { stockCsvFilter } from "../../utils/common/csvMappings/deviceStockCsv";
//import { ExportToCsv } from "export-to-csv";

function DeviceStock(props) {
  const {
    tableContainedData,
    filterValue,
    //CustomCardStock,
    url,
    csvEndPointUrl,
    isCsvActive,
    fetchCsvData,
    csvLoading,
  } = props;
  // console.log(tableContainedData);
  return (
    <>
      <div className="d-none d-sm-none col-12">
        <div
          id="carousel-div"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="0"
              className="active"
            ></button>
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="1"
            ></button>
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="2"
            ></button>
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="3"
            ></button>
            {filterValue.selectedPartnerRoleName !== "ARD" &&
            filterValue.selectedPartnerRoleName !== "MARD" ? (
              <button
                type="button"
                data-bs-target="#carousel-div"
                data-bs-slide-to="4"
              ></button>
            ) : null}
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <CustomCardStock
                tileName="Jio Bharat"
                value={tableContainedData.jioBharatQtyCount}
                cardColor="bluecol"
                icon="telephone"
                csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
                loading={csvLoading}
              />
            </div>
            <div className="carousel-item">
              <CustomCardStock
                tileName="Jio Phone"
                value={tableContainedData.pbQtyCount}
                cardColor="yellocol"
                icon="tablet"
                csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
                loading={csvLoading}
              />
            </div>
            <div className="carousel-item">
              <CustomCardStock
                tileName="Jio Phone Next"
                value={tableContainedData.jioPhoneNextQtyCount}
                cardColor="pinkcol"
                icon="tablet"
                csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
                loading={csvLoading}
              />
            </div>
            <div className="carousel-item">
              <CustomCardStock
                tileName="Partner Brand"
                value={tableContainedData.partnerBrandQtyCount}
                cardColor="redcol"
                icon="gadget"
                csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
                loading={csvLoading}
              />
            </div>
            <div className="carousel-item">
              <CustomCardStock
                tileName="JioFI"
                value={tableContainedData.jioQtyCount}
                cardColor="greencol"
                icon="router"
                csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
                loading={csvLoading}
              />
            </div>
            {filterValue.selectedPartnerRoleName !== "ARD" &&
            filterValue.selectedPartnerRoleName !== "MARD" ? (
              <div className="carousel-item">
                <CustomCardStock
                  tileName="Accessories"
                  value={tableContainedData.paQtyCount}
                  cardColor="redcol"
                  icon="gadget"
                  csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
                  loading={csvLoading}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className=" d-sm-block col-12">
        <div className="row">
          <CustomCardStock
            tileName="Jio Bharat"
            value={url.includes('retailer') ? '0': tableContainedData.jioBharatQtyCount}
            cardColor="bluecol"
            icon="telephone"
            csvDownload={(props.isCsvActive === "Y" && !url.includes('retailer')) ? fetchCsvData : ""}
            loading={csvLoading}
          />
          <CustomCardStock
            tileName="Jio Phone"
            value={url.includes('retailer') ? '0': tableContainedData.pbQtyCount}
            cardColor="yellocol"
            icon="tablet"
            csvDownload={(props.isCsvActive === "Y" && !url.includes('retailer')) ? fetchCsvData : ""}
            loading={csvLoading}
          />
          <CustomCardStock
            tileName="Jio Phone Next"
            value={url.includes('retailer') ? '0': tableContainedData.jioPhoneNextQtyCount}
            cardColor="pinkcol"
            icon="tablet"
            csvDownload={(props.isCsvActive === "Y" && !url.includes('retailer')) ? fetchCsvData : ""}
            loading={csvLoading}
          />
          <CustomCardStock
            tileName="Partner Brand"
            value={url.includes('retailer') ? '0': tableContainedData.partnerBrandQtyCount}
            cardColor="purplecol"
            icon="gadget"
            csvDownload={(props.isCsvActive === "Y" && !url.includes('retailer')) ? fetchCsvData : ""}
            loading={csvLoading}
          />
          <CustomCardStock
            tileName="JioFI"
            value={url.includes('retailer') ? '0': tableContainedData.jioQtyCount}
            cardColor="greencol"
            icon="router"
            csvDownload={(props.isCsvActive === "Y" && !url.includes('retailer')) ? fetchCsvData : ""}
            loading={csvLoading}
          />
          {filterValue.selectedPartnerRoleName !== "ARD" &&
          filterValue.selectedPartnerRoleName !== "MARD" ? (
            <CustomCardStock
              tileName="Accessories"
              value={url.includes('retailer') ? '0': tableContainedData.paQtyCount}
              cardColor="redcol"
              icon="gadget"
              csvDownload={(props.isCsvActive === "Y" && !url.includes('retailer')) ? fetchCsvData : ""}
              loading={csvLoading}
            />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default DeviceStock;
